<template>
  <div class="wrapper" style="overflow:hidden">
    <el-carousel trigger="click" :interval="5000" style="height:100vh">
      <el-carousel-item
        v-for="item in carousel"
        :key="item.image"
        style="height:100vh;"
      >
        <div class="carousel-center">
          <h2>{{ item.caption }}</h2>
          <h1 style="font-size:72px; font-weight:bold">{{ item.title }}</h1>
          <md-button
            href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
            class="md-primary md-sm"
            target="_blank"
          >
            <i class="fas fa-play" /> Watch video
          </md-button>
        </div>

        <div class="full-carousel-image darkened">
          <img :src="item.image" :alt="image.title" />
        </div>
      </el-carousel-item>
    </el-carousel>
    <div class="main">
      <div class="section">
        <div class="container">
          <div class="section section-features-1 pt-0">
            <div class="container">
              <div class="md-layout md-alignment-center">
                <!-- Services Items Start -->
                <div
                  class="md-layout-item md-size-33 md-small-size-100"
                  v-for="(service, index) in services"
                  :key="index"
                >
                  <info-areas info-horizontal>
                    <img :src=service.image />
                    <h4 slot="title" class="info-title">{{ service.title }}</h4>
                    <div slot="content" class="description">
                      <p>{{ service.description }}</p>
                      <a href="javascript:void(0)">Find more...</a>
                    </div>
                  </info-areas>
                  <!-- Services Items End -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- About us starts -->

        <!-- <div class="md-layout md-alignment-center" style="flex-wrap: nowrap;">
          <div class="md-layout-item md-size-50 md-small-size-100">
            <img :src="whatSetsUsApart.left.image" />
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100 text-center">
            <h3 class="whatSetsUsApart-content">
              {{ aboutUs.title }}
            </h3>
            <p class="whatSetsUsApart-content">
              {{ aboutUs.info }}
            </p>
          </div>
          <div class="md-layout-item md-size-25 md-small-size-100" style>
            <img :src="whatSetsUsApart.left.image" style />
          </div>
        </div>

        // Test section -->


        <div style="margin-left: 0; margin-right: 0; position: relative;">
          <img :src="aboutUs.image" style="width: 100%">
          <div style="position: absolute; top: 0; left: 50%; background-color: white; width: 31%; height: 100%; padding: 2%;" class="text-center">
            <div style="margin-top: 40%">
              <h3 class="whatSetsUsApart-content">
                {{ aboutUs.title }}
              </h3>
              <p class="whatSetsUsApart-content">
                {{ aboutUs.info }}
              </p>
            </div>
          </div>
        </div>

        <!-- About us ends -->

        <!-- What sets us apart start -->

        <!-- Features 5 -->
        <div class>
          <div class="md-layout" style="margin-left:0; margin-right:0;">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center"
            >
              <h2 class="title">What makes us different</h2>
            </div>
          </div>

          <!-- Layout begins -->
          <div
            class="md-layout"
            style="margin-left:0; margin-right:0; background-color: whitesmoke;"
          >
            <!-- Left slide -->
            <div
              class="md-layout-item md-size-32 md-small-size-100"
              style="height: 80vh; padding:0;"
            >
              <div class="md-layout" style="margin-left:0; margin-right:0;  ">
                <!-- Left top -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                  style="height: 40vh; padding: 0"
                >
                  <img
                    :src="whatSetsUsApart.left.image"
                    style="height: 40vh; width: 100%"
                  />
                </div>
                <!-- Left bottom -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100"
                  style="height: 40vh"
                >
                  <div class="text-center whatSetsUsApart-container">
                    <h3 class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.left.title }}
                    </h3>
                    <p class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.left.info }}
                    </p>
                  </div>
                  <md-divider
                    style="background-color: midnightblue; height:1px; margin-left: 40%; margin-right:40%; width: auto;"
                  ></md-divider>
                </div>
              </div>
            </div>

            <!-- Middle slide -->
            <div
              class="md-layout-item md-size-32 md-small-size-100"
              style="background-color: whitesmoke; height: 80vh; padding:0;"
            >
              <div class="md-layout" style="margin-left:0; margin-right:0;  ">
                <!-- Middle top -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100"
                  style="height: 40vh"
                >
                  <div class="text-center whatSetsUsApart-container">
                    <h3 class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.middle.title }}
                    </h3>
                    <p class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.middle.info }}
                    </p>
                  </div>
                  <md-divider
                    style="background-color: midnightblue; height:1px; margin-left: 40%; margin-right:40%; width: auto;"
                  ></md-divider>
                </div>
                <!-- Middle bottom -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                  style="height: 40vh; padding: 0"
                >
                  <img
                    :src="whatSetsUsApart.middle.image"
                    style="height: 40vh; width: 100%"
                  />
                </div>
              </div>
            </div>

            <!-- Right slide -->
            <div
              class="md-layout-item md-size-32 md-small-size-100"
              style="height: 80vh; padding:0;"
            >
              <div class="md-layout" style="margin-left:0; margin-right:0;  ">
                <!-- Right top -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100 subtle-shadow"
                  style="height: 40vh; padding: 0"
                >
                  <img
                    :src="whatSetsUsApart.right.image"
                    style="height: 40vh; width: 100%"
                  />
                </div>
                <!-- Right bottom -->
                <div
                  class="md-layout-item md-size-100 md-small-size-100"
                  style="height: 40vh"
                >
                  <div class="text-center whatSetsUsApart-container">
                    <h3 class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.right.title }}
                    </h3>
                    <p class="whatSetsUsApart-content">
                      {{ whatSetsUsApart.right.info }}
                    </p>
                  </div>
                  <md-divider
                    style="background-color: midnightblue; height:1px; margin-left: 40%; margin-right:40%; width: auto;"
                  ></md-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- What sets us apart end -->

        <!-- Clients start -->
<!-- 
        <agile :options="clients.options">
          <div class="md-layout md-alignment-center"></div>
        </agile> -->

        <!-- Clients End -->

        <h2 class="title text-center">Our portfolio</h2>

        <!-- Portfolio tabs start -->
        <div class="md-layout section">
          <div
            class="md-layout-item md-size-100 md-small-size-100"
            style="padding-right:0; padding-left: 0;"
          >
            <!-- <tabs
              :tab-active="1"
              :tab-name="serviceList"
              :tab-icon="['dashboard', 'schedule', 'list']"
              plain
              nav-pills
              color-button="primary"
              pillsAlign="center"
            > -->
              <!-- here you can add your content for tab-content -->

              <!-- Slot 1 starts -->
              <!-- <div slot="tab-pane-1"> -->
                <masonry :cols="{ default: 3, 700: 2, 400: 1 }" :gutter="5">
                  <div v-for="(item, index) in portfolio.wallart" :key="index">
                    <div class="portfolio-container" style="margin-bottom: 5px;">
                      <img :src="item.image" :alt="item.title" />
                      <div class="portfolio-overlay">
                        <md-divider class="portfolio-divider"></md-divider>
                        <h3 class="portfolio-title">{{ item.title }}</h3>
                        <h5 class="portfolio-caption">{{ item.text }}</h5>
                      </div>
                    </div>
                  </div>
                </masonry>
              <!-- </div> -->
              <!-- Slot 1 ends -->
            <!-- </tabs> -->
          </div>
        </div>
        <!-- Portfolio end -->

        <!-- TODO Connect this to scroll event -->

        <!-- Counters begin -->
        <div
          class="md-layout md-alignment-center"
          style="margin-right: 10vw; margin-left:10vw; margin-top: 0;"
        >
          <div
            class="md-layout-item md-size-25"
            v-for="(counter, index) in counters"
            :key="index"
          >
            <info-areas info-horizontal icon-color="info">
              <h2 slot="title" style="margin-bottom: 0;">
                <img :src="counter.image"/>
                <countTo
                class="text-primary"
                  :startVal="counter.start"
                  :endVal="counter.end"
                  :duration="counterDuration"
                ></countTo>
              </h2>
              <h3 slot="content" style="margin-top: 0;">{{ counter.title }}</h3>
            </info-areas>
          </div>
        </div>
        <!-- Counters end -->

        <!-- Testimonials Begin -->

        <!-- Testimonials Begin -->

      <!-- https://element.eleme.io/?ref=madewithvuejs.com#/en-US/component/carousel -->

      <div class="section section-testimonials-2 section-dark">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <el-carousel
                indicator-position="outside"
                arrow="never"
                trigger="click"
                :interval="5000"
              >
                <el-carousel-item v-for="testimonial in testimonials" :key="testimonial.title" class="testimonial-slider">
                  <testimonial-card card-plain transparent>
                    <div slot="cardAvatarTop" class="md-card-avatar mt-0">
                      <a href="javascript:void(0)">
                        <img class="img" :src="testimonial.image" />
                      </a>
                    </div>
                    <template slot="cardContent">
                      <h5 class="card-description">
                        {{testimonial.description}}
                      </h5>
                      <h4 class="card-title">{{testimonial.title}}</h4>
                      <h6 class="card-category text-muted">
                        {{testimonial.author}}
                      </h6>
                    </template>
                  </testimonial-card>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </div>
      </div>
      <!--Testimonials End -->

      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { Tabs, InfoAreas, TestimonialCard } from "@/components";
import { VueAgile } from "vue-agile";
import countTo from "vue-count-to";

export default {
  components: {
    Tabs,
    InfoAreas,
    agile: VueAgile,
    countTo,
    TestimonialCard
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "landing-page",
  data() {
    return {
      image: require("@/assets/img/landing-illustration.jpg"),
      aboutUs: {
        title: "Artists bleed creativity.",
        info: `A flow of passionate colours makes up our team. From carrying forward the artistic legacy, painting the town with the modern thought, ushering in awareness, providing digital marketing solutions, we ace it all. `,
        image: require("@/assets/img/landing/cool_mask.png")
      },
      services: [
        {
          title: "Spotlight Scouts",
          description: `To fuel your E-Business strategy, we provide a web of customized solutions.  `,
          icon: 'airplay',
          image: require("@/assets/img/landing/portfolio/wallart/1.jpg")
        },
        {
          title: "Epoxy Resin furniture",
          description: `An elegant and glossy finish for your furnishing.  `,
          icon: 'airplay'
        },
        {
          title: "Snehin (Hand-printed Fabrics)",
          description: `Striving to deliver fabricated bliss to transform every Woman’s life! `,
          icon: 'airplay'
        },
        {
          title: "Wall Art, Murals, Graffiti",
          description: `Fabricated artwork solutions to reshape your outdoor advertising! `,
          icon: 'airplay'
        },
        {
          title: "Interior Design",
          description: ` Let our eye for detail inhabit your mind’s space!  `,
          icon: 'airplay'
        },
        {
          title: "Art Workshops",
          description: ` We’re branching out to nurture the tricks of OUR trade-in you!  `,
          icon: 'airplay'
        }
      ],
      serviceList: [
        "Wall art",
        "Spotlight Scouts",
        "Snehin",
        "Epoxy",
        "Workshops"
      ],
      name: null,
      email: null,
      message: null,
      cardProfile3: {
        cardProfile1: require("@/assets/img/faces/card-profile1-square.jpg"),
        cardProfile2: require("@/assets/img/faces/card-profile6-square.jpg"),
        cardProfile3: require("@/assets/img/faces/card-profile4-square.jpg"),
        cardProfile4: require("@/assets/img/faces/card-profile2-square.jpg")
      },
      whatSetsUsApart: {
        left: {
          title: "True and Unique",
          info: `We at Artysan believe in the truth our colours present to the world. Trusting our creative flair, we look forward to displaying our unique arts through different media. Every art piece we make is distinct to suit your requirements.`,
          image: require("@/assets/img/landing/true_and_unique.png")
        },
        middle: {
          title: "Customised Solutions",
          info: `We have done it all from hand-painted walls to the customised details of your saree pallu. We have the potential to live your dreams on the canvass. We customise art as per your recommendations.`,
          image: require("@/assets/img/landing/customised_solutions.png")
        },
        right: {
          title: "Proficient and Efficient",
          info: `With our talented, proficient and efficient members, we aim to deliver high-quality products and services to you. Our customers always come first. `,
          image: require("@/assets/img/landing/proficient_and_efficient.png")
        }
      },
      clients: {
        options: {
          autoplay: true,
          centerMode: true,
          dots: false,
          navButtons: false,
          slidesToShow: 3,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1000,
              settings: {
                navButtons: true
              }
            }
          ]
        },
        icons: []
      },
      portfolio: {
        wallart: [
            {
              image: require("@/assets/img/landing/portfolio/wallart/1.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/2.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/3.jpeg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/4.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/5.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/6.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/7.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/8.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/9.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/10.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/11.png"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            },
            {
              image: require("@/assets/img/landing/portfolio/wallart/12.jpg"),
              title: "Pub Ji Cafe",
              text: "Walls may have ears but they can also have Pub Jis"
            }
          ]
      },

      counterDuration: 3000,
      counters: [
        {
          start: 0,
          end: 1000,
          title: "Spaces Embellished ",
          image: "https://img.icons8.com/dusk/50/000000/room.png"
        },
        {
          start: 0,
          end: 3000,
          title: "Gratified Clients",
          image: "https://img.icons8.com/bubbles/50/000000/group.png"
        },
        {
          start: 0,
          end: 3000,
          title: "Weeks doing Business",
          image: "https://img.icons8.com/cute-clipart/50/000000/planner.png"
        },
        {
          start: 0,
          end: 3000,
          title: "Hours Invested ",
          image: "https://img.icons8.com/plasticine/50/000000/clock--v2.png"
        }
      ],
      carousel: [
        {
          image: require("@/assets/img/home-carousel/1.jpg"),
          title: "Curated Aesthetics to Match your Vision!",
          caption: "We Aspire to Inspire"
        },
        {
          image: require("@/assets/img/home-carousel/2.jpg"),
          title: "Tailored Deliverables at your Fingertips!",
          caption: "We Provide Refined Options"
        },
        {
          image: require("@/assets/img/home-carousel/3.jpg"),
          title: "Embark on this Vivid Experience with us!",
          caption: "We’re a Team of Passionate Members"
        }
      ],
      testimonials: [
        {
          title: "Yourshell",
          author: "Sunny Garg",
          description: `It gives us great pleasure to have customized
designs in the form of Murals as Team Artysan pays great attention to
detailing, carving out such lovely art pieces, and really impressing us all!
Our interiors have never looked better!`,
          image: 'data:image/png;base64,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'
        },
        {
          title: "Machine Exim Engineering",
          author: "Nitin Mahajan",
          description: `We’ve noticed a significant
rise in customers after getting some interesting Wall Art paintings
thanks to the team at Artysan. This boost has helped our business pick
up the pace and the artwork are just extraordinary!`,
          image: require("@/assets/img/logos/eximeng.png")
        },
        {
          title: "Shubhi",
          author: "",
          description: `Placed an order for some hand-painted Kurtis and was truly
happy to see how much passion and creativity has gone into designing
them! Definitely expanding my wardrobe with Artysan’s unique collection!`,
          image: ''
        },
        {
          title: "Deepak Dagar",
          author: "Oasis",
          description: `Partnering with the brilliant team at Artysan has
given us a touch of exclusivity and professionalism! They displayed their
artistic magic on the compound walls of our premises that has gained
much attention! It has really contributed to the overall beauty of our
locality!`,
          image: require("@/assets/img/logos/OasisLogo.png")
        },
        {
          title: "DatStop",
          description: `Creativity through Artysan’s Wall Art really enlivened our
hostels’ infrastructure by transforming our vibe. Their quality of work is
way different than other freelancers, which really encourages us to have a
long-term business relation with them!`,
          image: 'data:image/jpeg;base64,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'
        },
        {
          title: "Urban Gurus",
          author: "Sahil Bajaj",
          description: `The lavish designs created by Team
Artysan helped me revamp my entire workplace. Now, my employees are
pumped up to enter a workplace that gives off such enthusiastic vibes.
Great choice in Decor!`,
          image: 'https://www.urbangurus.in/uploads/ae13014bd27143d2162bacc6ccb10036.png'
        },
        {
          title: "Ocean View Logistics Pvt Ltd",
          author: "Shagun Indoriya",
          description: `Just wanted to thank
you for all your amazing work. You took care of everything like you
promised! I got a number of compliments at the opening and I am so
glad we picked you!! Thanks again`,
          image: 'https://bestdataprovider.com/wp-content/uploads/Oceanview-Logistics-Oceanview-Logistics.png'
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}

.testimonial-slider {
  background: transparent !important;
}
</style>
